import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class StaffOJTsTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      staff_ojts: [],
    };
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.staff_ojts)) {
      this.setState({staff_ojts: newProps.staff_ojts});
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">OJTS</h3>
  <hr/>
  <BootstrapTable data={this.state.staff_ojts} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há OJTS cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
    
    <TableHeaderColumn dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Tarefa</TableHeaderColumn>

    <TableHeaderColumn dataField="ojt_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Tarefa</TableHeaderColumn>

    <TableHeaderColumn dataField="ojt_level" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Nível da Tarefa</TableHeaderColumn>

    <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Data de início</TableHeaderColumn>

    <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Data de fim</TableHeaderColumn>

    <TableHeaderColumn dataField="trained_role" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Função Treinada</TableHeaderColumn>

    <TableHeaderColumn dataField="aircraft_model_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Frota</TableHeaderColumn>

    <TableHeaderColumn dataField="aircraft_model_subtype_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Motor</TableHeaderColumn>

    <TableHeaderColumn dataField="manufacturer_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Fabricante</TableHeaderColumn>

    <TableHeaderColumn dataField="base_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Base</TableHeaderColumn>

    <TableHeaderColumn dataField="examiner_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Avaliador responsável</TableHeaderColumn>

    <TableHeaderColumn dataField="result" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='130'>Satisfatório</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default StaffOJTsTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffOJTsTab.js